<template>
  <div class="article-page">
    <!-- ===== 加载状态 ===== -->
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <p>文章加载中...</p>
    </div>

    <div v-else-if="articleData" class="article-wrapper">
      <!-- ===== 面包屑 ===== -->
      <div class="breadcrumb">
        <span>首页</span>
        <span class="separator">/</span>
        <span>资讯中心</span>
        <span class="separator">/</span>
        <span class="current">文章详情</span>
      </div>

      <!-- ===== 左右布局 ===== -->
      <div class="article-content">
        <!-- ===== 左侧：文章内容 ===== -->
        <div class="article-main">
          <h1 class="article-title">{{ articleData.title }}</h1>

          <!-- 文章元信息 -->
          <div class="article-meta" v-if="hasMetaInfo">
            <span class="source" v-if="enterpriseData.name || articleData.source">
              {{ enterpriseData.name || articleData.source }}
            </span>
            <span class="vip-tag" v-if="enterpriseData.vip">VIP会员</span>
            <span class="date" v-if="articleData.publishTime">
              {{ formatDate(articleData.publishTime) }}
            </span>
            <span class="views" v-if="articleData.author || articleData.viewCount">
              {{ articleData.author ? articleData.author + ' ' : '' }}{{ articleData.viewCount ? '阅读 ' + articleData.viewCount : '' }}
            </span>
          </div>

          <!-- 企业联系方式 -->
          <div class="contact-info" v-if="enterpriseData.contactPerson || enterpriseData.mobile || enterpriseData.telephone">
            <div class="contact-row" v-if="enterpriseData.contactPerson">
              <span class="label">联系人：</span>
              <span class="value">{{ enterpriseData.contactPerson }}</span>
            </div>
            <div class="contact-row" v-if="enterpriseData.mobile || enterpriseData.telephone">
              <span class="label">电话：</span>
              <span class="phone">{{ enterpriseData.mobile || enterpriseData.telephone }}</span>
              <span class="desc" v-if="enterpriseData.mobile">（7x24小时咨询）</span>
            </div>
            <div class="contact-row" v-if="enterpriseData.qq">
              <span class="label">QQ：</span>
              <span class="value">{{ enterpriseData.qq }}</span>
            </div>
            <div class="contact-row" v-if="enterpriseData.fullAddress">
              <span class="label">地址：</span>
              <span class="value">{{ enterpriseData.fullAddress }}</span>
            </div>
          </div>

          <!-- 企业主营产品标签 -->
          <div class="tag-group" v-if="enterpriseData.zycp">
            <span class="tag" v-for="(tag, idx) in getProductTags(enterpriseData.zycp)" :key="idx">
              {{ tag }}
            </span>
          </div>

          <!-- 文章正文 -->
          <div class="article-body" v-html="articleData.content"></div>

          <!-- 企业简介 -->
          <div class="company-intro" v-if="enterpriseData.description">
            <h4>企业简介</h4>
            <p>{{ enterpriseData.description }}</p>
          </div>
        </div>

        <!-- ===== 右侧：热门商机 ===== -->
        <aside class="article-sidebar">
          <div class="sidebar-title">
            <h4>热门商机</h4>
          </div>
          <ul class="hot-opportunities">
            <li 
              v-for="(item, index) in rightHotList" 
              :key="item.articleId || index"
              @click="goToArticle(item)"
            >
              <span class="hot-index">{{ index + 1 }}</span>
              <span class="hot-text">{{ item.title }}</span>
            </li>
          </ul>
        </aside>
      </div>
    </div>

    <!-- ===== 文章不存在 ===== -->
    <div v-else class="empty-tip">
      <p>{{ errorMessage || '文章不存在或已被删除' }}</p>
      <router-link to="/">返回首页</router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ArticleView',
  data() {
    return {
      articleData: null,
      enterpriseData: {},
      rightHotList: [],
      loading: true,
      errorMessage: ''
    }
  },
  computed: {
    hasMetaInfo() {
      return !!(this.enterpriseData.name || this.articleData.source ||
                this.enterpriseData.vip || this.articleData.publishTime ||
                this.articleData.author || this.articleData.viewCount)
    }
  },
  created() {
    this.fetchAllData()
  },
  methods: {
    updateHeadMeta() {
      if (!this.articleData) return
      document.title = this.articleData.title + ' | 云商机平台'
      let kw = document.querySelector('meta[name="keywords"]')
      if (!kw) {
        kw = document.createElement('meta')
        kw.name = 'keywords'
        document.head.appendChild(kw)
      }
      kw.content = this.articleData.seoKeywords || ''
      let desc = document.querySelector('meta[name="description"]')
      if (!desc) {
        desc = document.createElement('meta')
        desc.name = 'description'
        document.head.appendChild(desc)
      }
      desc.content = this.articleData.seoDesc || this.articleData.summary || this.articleData.title || ''
    },
    async fetchAllData() {
      const articleId = this.$route.query.articleId
      if (!articleId) {
        this.loading = false
        this.errorMessage = '缺少文章ID参数'
        return
      }

      this.loading = true
      this.errorMessage = ''
      try {
        const [detailRes, listRes] = await Promise.all([
          axios.get('https://b2b.sdfangcun.com/prod-api/system/article/acontent', {
            params: { articleId }
          }),
          axios.get('https://b2b.sdfangcun.com/prod-api/system/article/newwebindex', {
            params: { pageNum: 1, pageSize: 100 }
          })
        ])

        if (detailRes.data.code === 200) {
          const data = detailRes.data.data
          this.articleData = data.article || null
          this.enterpriseData = data.enterprise || {}
          this.updateHeadMeta()
        } else {
          this.errorMessage = detailRes.data.msg || '文章加载失败'
          this.updateHeadMeta()
        }

        if (listRes.data.code === 200) {
          const articles = listRes.data.data.article || []
          const filtered = articles.filter(item => String(item.articleId) !== String(articleId))
          this.rightHotList = filtered.slice(0, 10)
        } else {
          this.rightHotList = []
        }

      } catch (err) {
        console.error('请求失败:', err)
        this.errorMessage = '网络请求失败，请稍后重试'
      } finally {
        this.loading = false
      }
    },

    goToArticle(item) {
      if (item && item.articleId) {
        this.$router.push({
          path: '/article',
          query: { articleId: item.articleId }
        })
      }
    },

    getProductTags(zycp) {
      if (!zycp) return []
      const tags = zycp.split(/[,，\n]+/).filter(t => t.trim())
      return tags.slice(0, 8)
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      try {
        const date = new Date(dateStr)
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`
      } catch {
        return ''
      }
    }
  },
  watch: {
    '$route.query.articleId': function(newId) {
      if (newId) {
        this.fetchAllData()
      }
    }
  }
}
</script>

<style scoped>
/* ===== 页面容器 ===== */
.article-page {
  padding: 20px 0 30px;
  background: #f8f9fa;
}

/* ===== 加载状态 ===== */
.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #c0392b;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.loading-wrapper p {
  margin-top: 16px;
  color: #999;
  font-size: 14px;
}

.empty-tip {
  text-align: center;
  padding: 60px 0;
}
.empty-tip p {
  font-size: 16px;
  color: #999;
  margin-bottom: 16px;
}
.empty-tip a {
  color: #c0392b;
  text-decoration: none;
  font-weight: 600;
}
.empty-tip a:hover {
  text-decoration: underline;
}

/* ===== 面包屑 ===== */
.breadcrumb {
  padding: 12px 0 18px;
  font-size: 14px;
  color: #888;
}
.breadcrumb .separator {
  margin: 0 8px;
  color: #ccc;
}
.breadcrumb .current {
  color: #c0392b;
  font-weight: 500;
}

/* ===== 文章主体布局 ===== */
.article-content {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

/* ===== 左侧文章内容 ===== */
.article-main {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  padding: 30px 35px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  min-width: 0;
}

.article-title {
  font-size: 26px;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1.4;
  margin-bottom: 16px;
}

.article-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 14px;
  font-size: 13px;
  color: #888;
}
.article-meta .source {
  color: #c0392b;
  font-weight: 500;
}
.article-meta .vip-tag {
  background: #f1c40f;
  color: #222;
  padding: 0 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  line-height: 20px;
}
.article-meta .date {
  color: #999;
}
.article-meta .views {
  color: #aaa;
  margin-left: auto;
}

.contact-info {
  background: #fef9f7;
  border-left: 4px solid #c0392b;
  padding: 14px 18px;
  margin-bottom: 16px;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
}
.contact-row {
  display: flex;
  align-items: center;
  padding: 2px 0;
}
.contact-row .label {
  color: #888;
  min-width: 60px;
  flex-shrink: 0;
}
.contact-row .value {
  color: #333;
}
.contact-row .phone {
  color: #c0392b;
  font-weight: 700;
  font-size: 18px;
  margin: 0 4px;
}
.contact-row .desc {
  color: #999;
  font-size: 13px;
}

.tag-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 12px 0 20px;
}
.tag-group .tag {
  background: #f0f0f0;
  color: #555;
  padding: 2px 16px;
  border-radius: 20px;
  font-size: 12px;
  line-height: 26px;
  border: 1px solid #e8e8e8;
}
.tag-group .tag:first-child {
  background: #c0392b;
  color: #fff;
  border-color: #c0392b;
}

/* ===== 文章正文 ===== */
.article-body {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  text-align: justify;
  word-wrap: break-word;
  overflow: visible; /* 确保不裁剪内容 */
}

/* ----- 深度选择器强制覆盖富文本图片，确保等比例缩放不溢出 ----- */
.article-body >>> img,
.article-body /deep/ img {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px 0;
  border: none;
  padding: 0;
  /* 不设置 width，让 max-width 自动控制 */
}

/* 表格横向滚动 */
.article-body >>> table,
.article-body /deep/ table {
  max-width: 100%;
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  border-collapse: collapse;
  margin: 16px 0;
}
.article-body >>> table td,
.article-body >>> table th,
.article-body /deep/ table td,
.article-body /deep/ table th {
  padding: 6px 12px;
  border: 1px solid #ddd;
  white-space: nowrap;
}

/* 其他媒体元素自适应 */
.article-body >>> iframe,
.article-body >>> video,
.article-body >>> embed,
.article-body /deep/ iframe,
.article-body /deep/ video,
.article-body /deep/ embed {
  max-width: 100%;
  height: auto;
}

.article-body h2 {
  font-size: 22px;
  color: #1a1a2e;
  margin: 24px 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}
.article-body h3 {
  font-size: 18px;
  color: #1a1a2e;
  margin: 18px 0 12px;
}
.article-body h4 {
  font-size: 16px;
  color: #1a1a2e;
  margin: 16px 0 10px;
}
.article-body p {
  margin-bottom: 16px;
}
.article-body ul,
.article-body ol {
  padding-left: 28px;
  margin-bottom: 16px;
}
.article-body li {
  margin-bottom: 6px;
}
.article-body strong {
  color: #1a1a2e;
}
.article-body a {
  color: #c0392b;
  text-decoration: none;
}
.article-body a:hover {
  text-decoration: underline;
}
.article-body blockquote {
  border-left: 4px solid #c0392b;
  padding: 8px 20px;
  margin: 16px 0;
  background: #f8f8f8;
  color: #555;
}

.company-intro {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}
.company-intro h4 {
  font-size: 16px;
  color: #1a1a2e;
  margin-bottom: 10px;
}
.company-intro p {
  font-size: 14px;
  line-height: 1.8;
  color: #555;
  white-space: pre-wrap;
}

/* ===== 右侧热门商机 ===== */
.article-sidebar {
  width: 340px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 12px;
  padding: 20px 22px 18px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  position: sticky;
  top: 20px;
}

.sidebar-title {
  padding-bottom: 14px;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 14px;
}
.sidebar-title h4 {
  font-size: 18px;
  color: #1a1a2e;
  font-weight: 600;
  padding-left: 12px;
  border-left: 4px solid #c0392b;
  margin: 0;
}

.hot-opportunities {
  list-style: none;
  padding: 0;
  margin: 0;
}
.hot-opportunities li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  transition: 0.15s;
  cursor: pointer;
}
.hot-opportunities li:hover {
  color: #c0392b;
}
.hot-opportunities .hot-index {
  display: inline-block;
  min-width: 22px;
  height: 22px;
  background: #e8e8e8;
  border-radius: 50%;
  text-align: center;
  line-height: 22px;
  font-size: 11px;
  font-weight: 600;
  color: #888;
  flex-shrink: 0;
  margin-top: 1px;
}
.hot-opportunities li:first-child .hot-index {
  background: #f1c40f;
  color: #222;
}
.hot-opportunities li:nth-child(2) .hot-index {
  background: #bdc3c7;
  color: #222;
}
.hot-opportunities li:nth-child(3) .hot-index {
  background: #e67e22;
  color: #fff;
}
.hot-opportunities .hot-text {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== 响应式 ===== */
@media (max-width: 1024px) {
  .article-content {
    flex-direction: column;
  }
  .article-sidebar {
    width: 100%;
    position: static;
  }
  .article-sidebar .hot-opportunities {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 20px;
  }
}
@media (max-width: 768px) {
  .article-main {
    padding: 20px;
  }
  .article-title {
    font-size: 20px;
  }
  .article-meta {
    font-size: 12px;
    gap: 10px;
  }
  .article-meta .views {
    margin-left: 0;
    width: 100%;
  }
  .article-sidebar .hot-opportunities {
    grid-template-columns: 1fr;
  }
  .contact-row .phone {
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  .article-main {
    padding: 14px;
  }
  .article-title {
    font-size: 18px;
  }
  .article-body {
    font-size: 14px;
  }
}
</style>